export default __webpack_public_path__ + "static/media/Malaki_Portfolio6.5b2a3762.webp";